export default __webpack_public_path__ + "3696f3f45190c9f011d51182daf1dada.svg";